import { render, staticRenderFns } from "./MemberInfo.vue?vue&type=template&id=2317bd2c&scoped=true"
import script from "./MemberInfo.vue?vue&type=script&lang=ts"
export * from "./MemberInfo.vue?vue&type=script&lang=ts"
import style0 from "./MemberInfo.vue?vue&type=style&index=0&id=2317bd2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2317bd2c",
  null
  
)

export default component.exports